<div *transloco="let t" class="sectionId_baukosten sectionAnchor flexBoxOuter">
  <div class="flexBoxInner txt marginRight" style="hyphens: auto">
    <div style="margin-bottom: 26px">
      <h4 data-translate="start.quickNav.build">{{ t("products.start.quickNav.effortPlanner") }}</h4>
    </div>

    <div style="margin-top: 33px">
      <h3 data-translate="build.title">{{ t("products.effortPlanner.title") }}</h3>
    </div>
    <div style="margin-top: 20px">
      <p
        class="brightfont"
        style="display: block; font-weight: bold"
        data-translate="effortPlanner.text-1-header"
        [innerHTML]="t('products.effortPlanner.text-1-header')"
      ></p>
      <p
        class="brightfont"
        style="display: inline"
        data-translate="effortPlanner.text-1-1"
        [innerHTML]="t('products.effortPlanner.text-1-1')"
      ></p>
      <br />
      <p
        style="display: inline; hyphens: auto"
        class="brightfont"
        data-translate="effortPlanner.text-1-2"
        [innerHTML]="t('products.effortPlanner.text-1-2')"
      ></p>
    </div>

    <p class="brightfont" style="margin-bottom: 10px">
      {{ t("products.products.free-until-end-year") }}
    </p>

    <div style="margin-bottom: 20px">
      <button
        *ngIf="!isAuthenticated"
        ui-sref="register"
        class="btn btn-elegant-black kw-btn-grid"
        id="buildingCostsAndDates"
        routerLink="register"
      >
        <span>{{ t("global.register-now") }}</span>
      </button>
      <ng-container *ngIf="isAuthenticated">
        <button
          ui-sref="process-form.input({withdrawalProductType: 'building_costs_and_dates'})"
          data-ui-sref-opts="{reload: 'operational-costs'}"
          class="btn btn-elegant-black kw-btn-grid"
          (click)="goToProcessForm()"
        >
          <mat-icon class="material-symbols-outlined" style="font-size: 20px; vertical-align: middle">
            play_arrow </mat-icon
          >&nbsp;
          <span>{{ t("products.calc_now") }}</span>
        </button>
      </ng-container>
      <a class="btn btn-elegant-black kw-btn-grid" ui-sref="accuracy" target="_blank" (click)="goToInfo()"
        >{{ t("products.learn_more") }}
      </a>
    </div>
    <ng-container ui-view="webinar"></ng-container>
  </div>

  <div class="flexBoxInner img">
    <div class="centerImage centerImgVertically">
      <img src="/assets/images/calculation/bg/benchmark-adjust.svg" style="align-self: center" />
    </div>
  </div>
</div>
